import { TextInput } from '@mantine/core';
import { useUnit } from 'effector-react';
import { gameModel } from 'entities/game';
import CoinIcon from 'shared/ui/assets/icons/coin-icon.svg?react';
import { calculatorBetModel } from '../../model';
import cls from './calculator-bet-wager-field.module.scss';

export const CalculatorBetWagerField = () => {
	const [currency, minBet, maxBet, value] = useUnit([
		gameModel.$currency,
		gameModel.$minBet,
		gameModel.$maxBet,
		calculatorBetModel.$wager,
	]);

	return (
		<TextInput
			readOnly
			min={minBet}
			max={maxBet}
			classNames={{
				wrapper: cls.calculatorBetWagerFieldWrapper,
			}}
			leftSection={<CoinIcon className={cls.calculatorBetWagerFieldCoin} />}
			rightSection={<span className={cls.calculatorBetWagerFieldCurrency}>{currency}</span>}
			leftSectionPointerEvents='none'
			rightSectionPointerEvents='none'
			value={value}
		/>
	);
};
